import { type TabItem, Tabs } from "@aurem/ui";
import { use, useCallback, useState } from "react";
import { useTranslations } from "../i18n";
import CurrencyTab from "./CurrencyTab";
import LanguageTab from "./LanguageTab";
import { LanguageCurrencyPickerContext } from "./context";

const LanguageCurrencyPickerContent = () => {
  const { t } = useTranslations();
  const {
    languages,
    currencies,
    currentLanguage,
    currentCurrency,
    onLanguageSelect,
    onCurrencySelect,
    supportedLanguages,
  } = use(LanguageCurrencyPickerContext);

  const tabItems: TabItem[] = [
    ...((supportedLanguages.length > 1 && [
      {
        id: `language`,
        text: t("components.languageCurrencyPicker.language.label"),
        content: (
          <LanguageTab
            languages={languages}
            currentLanguage={currentLanguage}
            onLanguageSelect={onLanguageSelect}
          />
        ),
      },
    ]) ||
      []),
    {
      id: `currency`,
      text: t("components.languageCurrencyPicker.currency.label"),
      content: (
        <CurrencyTab
          currencies={currencies}
          currentCurrency={currentCurrency}
          onCurrencySelect={onCurrencySelect}
        />
      ),
    },
  ];
  const [activeItem, setActiveItem] = useState(tabItems[0].id);

  const handleTabChange = useCallback((id: string) => {
    setActiveItem(id);
  }, []);

  return (
    <Tabs
      items={tabItems}
      activeItem={activeItem}
      onChange={handleTabChange}
      variant="fill"
      className="gap-6"
    />
  );
};

export default LanguageCurrencyPickerContent;
